/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsDeleteReportDefinitionMutationResponse, AuditReportsDeleteReportDefinitionPathParams, AuditReportsDeleteReportDefinition400, AuditReportsDeleteReportDefinition401, AuditReportsDeleteReportDefinition403, AuditReportsDeleteReportDefinition404 } from "../models/AuditReportsDeleteReportDefinition";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsDeleteReportDefinition } from "../axios/auditReportsDeleteReportDefinition";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsDeleteReportDefinitionMutationKey = () => [{ url: '/audit-reports/v1/report-definitions/:id' }] as const

export type AuditReportsDeleteReportDefinitionMutationKey = ReturnType<typeof auditReportsDeleteReportDefinitionMutationKey>

export function auditReportsDeleteReportDefinitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = auditReportsDeleteReportDefinitionMutationKey()
        return mutationOptions<AuditReportsDeleteReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsDeleteReportDefinition400 | AuditReportsDeleteReportDefinition401 | AuditReportsDeleteReportDefinition403 | AuditReportsDeleteReportDefinition404>, {id: AuditReportsDeleteReportDefinitionPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return auditReportsDeleteReportDefinition(id, config)
          },
        })

}

/**
 * @description Deletes a report definition by its unique identifier. Cannot delete if it is the only definition for the report type or if it is the default definition.
 * @summary Delete report definition
 * {@link /audit-reports/v1/report-definitions/:id}
 */
export function useAuditReportsDeleteReportDefinition<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsDeleteReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsDeleteReportDefinition400 | AuditReportsDeleteReportDefinition401 | AuditReportsDeleteReportDefinition403 | AuditReportsDeleteReportDefinition404>, {id: AuditReportsDeleteReportDefinitionPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsDeleteReportDefinitionMutationKey()

          const baseOptions = auditReportsDeleteReportDefinitionMutationOptions(config) as UseMutationOptions<AuditReportsDeleteReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsDeleteReportDefinition400 | AuditReportsDeleteReportDefinition401 | AuditReportsDeleteReportDefinition403 | AuditReportsDeleteReportDefinition404>, {id: AuditReportsDeleteReportDefinitionPathParams["id"]}, TContext>
          

          return useMutation<AuditReportsDeleteReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsDeleteReportDefinition400 | AuditReportsDeleteReportDefinition401 | AuditReportsDeleteReportDefinition403 | AuditReportsDeleteReportDefinition404>, {id: AuditReportsDeleteReportDefinitionPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsDeleteReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsDeleteReportDefinition400 | AuditReportsDeleteReportDefinition401 | AuditReportsDeleteReportDefinition403 | AuditReportsDeleteReportDefinition404>, {id: AuditReportsDeleteReportDefinitionPathParams["id"]}, TContext>
      
}